import React                   from 'react';
import {Trans, useTranslation} from 'react-i18next';
import Card                    from '@mui/material/Card';
import CardContent             from '@mui/material/CardContent';
import Typography              from '@mui/material/Typography';
import {Title}                 from '../../../typography/Title';

const Likes = ({count}) => {
	const {t} = useTranslation();

	return (
		<Card variant="outlined">
			<CardContent>
				<Title>{t('likes_title')}</Title>
				<Typography variant="body2" color="textSecondary" component="p">
					<Trans i18nKey="likes_stats" count={count}>
						You have <Typography color="secondary" component="span">{{count}}</Typography> users(s) that
						liked this content
					</Trans>
				</Typography>
			</CardContent>
		</Card>
	);
};


export default Likes;
